
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { BiSearchAlt2 } from "react-icons/bi";
import { ChangeEvent, useState, useEffect, useRef } from "react";
import { ProjectsListTable } from "../components/ProjectsListTable";
import { Input, Paper } from "@mantine/core";
import { Modal } from '@mantine/core';
import { useDisclosure } from "@mantine/hooks";
import ProjectsForm from "../components/ProjectsForm";
import { useDispatch, useSelector } from "react-redux";
import boule from "../../../resources/img/boule.png";
import { selectCurrentUser } from "../../../auth/AuthUserSlice";
import { useTranslation } from "react-i18next";


const ListProjects = () => {

  const navigate = useNavigate();
  const {t} = useTranslation("common");
  const currentUser = useSelector(selectCurrentUser);
  const [queryFilter, setQueryFilter] = useState(`createdBy==${currentUser.preferred_username}`);
  const [opened, { open, close }] = useDisclosure(false);
  const dispatch = useDispatch();

  var Timer = setTimeout(()=>{},1000);

  function searchProject(e: ChangeEvent) {
    const target = e.target as HTMLInputElement;
      clearTimeout(Timer);
      Timer = setTimeout(function () {
          if (target.value.length >= 3) {
            setQueryFilter(
              `createdBy==${currentUser.preferred_username},(name)@=*` + target.value  // |locationCity|locationCountry|status
            );
          }else if(target.value.length == 0) {
            setQueryFilter(`createdBy==${currentUser.preferred_username}`);
          }
      }, 1000);
  };

  return (
    <>
        <main>
          <section>
              {/* <div className="row h-370 pt-50">
                <div className="col-md-6">
                  <div className="project-text-header">
                      <h1>Vous avez choisi l'axe: <span className="color-primary">Autisme</span></h1>
                      <h3>Etat d'avancement de mes projets</h3>
                      <p>
                          Bien vouloir remplir scrupuleusement toutes les étapes du formulaire afin de soumettre votre dossier pour étude... <br/><br/>
                          NB: <strong className="color-primary">* Champs Obligatoire</strong>
                      </p>
                  </div>
                </div>
                <div className="col-md-6">
                     <img className="img-position" src={boule} alt="header image" /> 
                </div>
              </div> */}
              <div id="card-content">
                  <div className="row">
                      <div className="card card-2 mmb-7 mt-3 ml-auto mr-auto">
                        <div className="card-body">
                            <div className="p-4">
                              <div className="mb-2">
                                <h3 className="mb-2">{ t('projet.state') }</h3> 
                                <hr />
                                <br />
                                <div className="d-flex mt-2">
                                  <div>
                                    <Paper
                                      component="form"
                                      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                      <Input
                                        sx={{ ml: 1, flex: 1 }}
                                        placeholder={ t('projet.search') }
                                        rightSection={<BiSearchAlt2 color="gray"/>}
                                        onChange={(e)=> searchProject(e)}
                                      />
                                    </Paper>
                                  </div>
                                  <div className="ml-auto">
                                    <Button
                                      onClick={() => open() }
                                      startIcon={<MdAdd /> }
                                      children={ t('projet.add') }
                                      style={{
                                        color:"#FF7900",
                                        backgroundColor:"#fff !important",
                                        width: "250px !important"
                                      }}
                                      sx={{
                                        backgroundColor:"#fff !important",
                                        textTransform: "none",
                                        fontSize: "12px",
                                        display: "none"
                                      }}
                                      className="ml-auto"
                                      variant="contained"
                                    />
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div className="mb-4">    
                                <ProjectsListTable queryFilter={queryFilter} />
                              </div>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
          </section>
        </main>
      <Modal opened={opened} onClose={close} size="lg" title="Enregistrement d'une Projet" centered withCloseButton> 
        <ProjectsForm />
      </Modal>  
    </>
  );
}
export default ListProjects;

